import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mrbox round darkfill menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "route-informatie", -1)
const _hoisted_3 = { class: "controlrow" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "css-label",
  for: "bereikbaarpertrein"
}, "Bereikbaar per trein", -1)
const _hoisted_6 = { class: "controlrow" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "css-label",
  for: "bereikbaarperov"
}, "Bereikbaar per OV", -1)
const _hoisted_9 = { class: "controlrow" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("input", {
  id: "meerdaagsewandeling",
  class: "css-checkbox",
  type: "checkbox",
  disabled: "",
  checked: ""
}, null, -1)
const _hoisted_11 = {
  class: "css-label",
  for: "meerdaagsewandeling"
}
const _hoisted_12 = { class: "controlrow" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("input", {
  id: "rondtocht",
  class: "css-checkbox",
  type: "checkbox",
  disabled: "",
  checked: ""
}, null, -1)
const _hoisted_14 = {
  class: "css-label",
  for: "rondtocht"
}
const _hoisted_15 = { class: "controlrow" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "css-label",
  for: "hondentoegestaan"
}, "Honden toegestaan", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.trail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            id: "bereikbaarpertrein",
            class: "css-checkbox",
            type: "checkbox",
            disabled: "",
            checked: _ctx.trail.bereikbaarPerTrein
          }, null, 8, _hoisted_4),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            id: "bereikbaarperov",
            class: "css-checkbox",
            type: "checkbox",
            disabled: "",
            checked: _ctx.trail.bereikbaarPerOv
          }, null, 8, _hoisted_7),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.meerdaagsLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.rondtochtLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("input", {
            id: "hondentoegestaan",
            class: "css-checkbox",
            type: "checkbox",
            disabled: "",
            checked: _ctx.trail.honden
          }, null, 8, _hoisted_16),
          _hoisted_17
        ]),
        _hoisted_18,
        (_ctx.trail.lastModified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Laatst gewijzigd: " + _toDisplayString(_ctx.trail.lastModified.toLocaleDateString('nl-NL',
      {year: "numeric", month: "long", day: "numeric"})), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}